import React from "react";
import { Link } from "react-router-dom";

// project-imports
import Image from "../../../common/footer/Images/Image";
import ToolTip from "../../../common/Tooltip/ToolTip";
import { useGalleryContext } from "../../../context/gallery_context";
import VideoContentWidgetStencil from "./VideoContentWidgetStencil";
import { GoogleAnalyticsEnum, triggerFunction } from "../../../utils/google-analytics";


function VideoContentWidgetV2({ data, classes, onOpenDrawer, onVideoToggle }) {

    // Extracting variables from context
    const { isLoading, isError } = useGalleryContext();

    // constants variables
    const videoTitle = (data && data?.cleanTitle) || "";
    const videoViews = (data && data?.viewdCount) || 0;
    const videoThumbnail = (data && data?.featuredImage) || "";

    const formatViews = (viewsString) => {
        // Extract only the digits from the input string
        const count = parseInt(viewsString.replace(/\D/g, ""), 10);

        if (isNaN(count)) return "0 Views";

        // Format to K if 1,000 or more, keeping one decimal place if needed
        if (count >= 1000) {
            const formatted = (count / 1000).toFixed(1).replace(/\.0$/, "");
            return `${formatted}K Views`;
        }

        return `${count} Views`;
    }

    if (isLoading) {
        return <VideoContentWidgetStencil />;
    }
    return (
        <div>
            <div class={`edu-blog-widget-2 widget-latest-post ${classes ? classes : ""}`}>
                <div class="inner y-gap-40">
                    <div class="content latest-post-list">
                        <div class="latest-post">
                            <div class="thumbnail">
                                <div class="d-block img-popular-video clickable">
                                    <Image src={videoThumbnail} className="rounded-16" alt="Thumbnail" onClick={() => { onVideoToggle(data?.videoUrl); triggerFunction(window.location.href + GoogleAnalyticsEnum.LSA_SALESFORCE_TUTORIALS_VIDEO_PLAYED_BUTTON_CLICKED, data?.cleanTitle); }} fill />
                                </div>
                            </div>
                            <div class="post-content">
                                <ToolTip title={videoTitle}>
                                    <h6 class="title truncate-2-lines fs-14 lh-25">
                                        <Link class="d-block"
                                            onClick={() => onOpenDrawer(data)}
                                        >
                                            {videoTitle}
                                        </Link>
                                    </h6>
                                </ToolTip>
                                <ul class="blog-meta">
                                    <li className="fs-10">{formatViews((videoViews || "").toString())}</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoContentWidgetV2;
